import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromPrivacyAndTerms from './reducers/privacy-and-terms.reducer';
import { EffectsModule } from '@ngrx/effects';
import { PrivacyAndTermsEffects } from './effects/privacy-and-terms.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('privacyAndTerms', fromPrivacyAndTerms.reducer),
    EffectsModule.forFeature([PrivacyAndTermsEffects])
  ]
})
export class PrivacyAndTermsModule { }
